import { render } from "./combatVue.vue?vue&type=template&id=3bc207de"
import script from "./combatVue.vue?vue&type=script&lang=js"
export * from "./combatVue.vue?vue&type=script&lang=js"

import "./combatVue.vue?vue&type=style&index=0&id=3bc207de&lang=css"
import "../assets/css/besoin.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__